export const getSidebarStructure = t => [
  {
    key: 'inbox',
    label: t('SIDEBAR.INBOX'),
    toName: 'inbox_view',
    activeOn: ['inbox_view_conversation'],
  },
  {
    key: 'conversation',
    label: t('SIDEBAR.CONVERSATIONS'),
    children: [
      {
        key: 'all_conversations',
        label: t('SIDEBAR.ALL_CONVERSATIONS'),
        toName: 'home',
        activeOn: ['inbox_conversation'],
      },
      {
        key: 'mentions',
        label: t('SIDEBAR.MENTIONED_CONVERSATIONS'),
        toName: 'conversation_mentions',
        activeOn: ['conversation_through_mentions'],
      },
      {
        key: 'unattended',
        label: t('SIDEBAR.UNATTENDED_CONVERSATIONS'),
        toName: 'conversation_unattended',
        activeOn: ['conversation_through_unattended'],
      },
      {
        key: 'folders',
        label: t('SIDEBAR.CUSTOM_VIEWS_FOLDER'),
        toName: 'folder_conversations',
        activeOn: ['conversations_through_folders'],
      },
      {
        key: 'teams',
        label: t('SIDEBAR.TEAMS'),
        toName: 'team_conversations',
        activeOn: ['conversations_through_team'],
      },
      {
        key: 'channels',
        label: t('SIDEBAR.CHANNELS'),
        toName: 'inbox_dashboard',
        activeOn: ['conversation_through_inbox'],
      },
      {
        key: 'labels',
        label: t('SIDEBAR.LABELS'),
        toName: 'label_conversations',
        activeOn: ['conversations_through_label'],
      },
    ],
  },
  {
    key: 'contacts',
    label: t('SIDEBAR.CONTACTS'),
    children: [
      {
        key: 'all_contacts',
        label: t('SIDEBAR.ALL_CONTACTS'),
        toName: 'contacts_dashboard_index',
        activeOn: ['contacts_edit'],
      },
      {
        key: 'active_contacts',
        label: t('SIDEBAR.ACTIVE'),
        toName: 'contacts_dashboard_active',
      },
      {
        key: 'segments',
        label: t('SIDEBAR.CUSTOM_VIEWS_SEGMENTS'),
        toName: 'contacts_dashboard_segments_index',
        activeOn: ['contacts_edit_segment'],
      },
      {
        key: 'contact_labels',
        label: t('SIDEBAR.TAGGED_WITH'),
        toName: 'contacts_dashboard_labels_index',
        activeOn: ['contacts_edit_label'],
      },
    ],
  },
  {
    key: 'companies',
    label: t('SIDEBAR.COMPANIES'),
    children: [
      {
        key: 'all_companies',
        label: t('SIDEBAR.ALL_COMPANIES'),
        toName: 'companies_dashboard_index',
      },
    ],
  },
  {
    key: 'reports',
    label: t('SIDEBAR.REPORTS'),
    children: [
      {
        key: 'reports_overview',
        label: t('SIDEBAR.REPORTS_OVERVIEW'),
        toName: 'account_overview_reports',
      },
      {
        key: 'reports_conversation',
        label: t('SIDEBAR.REPORTS_CONVERSATION'),
        toName: 'conversation_reports',
      },
      {
        key: 'reports_agent',
        label: t('SIDEBAR.REPORTS_AGENT'),
        toName: 'agent_reports_index',
        activeOn: ['agent_reports_show'],
      },
      {
        key: 'reports_label',
        label: t('SIDEBAR.REPORTS_LABEL'),
        toName: 'label_reports_index',
      },
      {
        key: 'reports_inbox',
        label: t('SIDEBAR.REPORTS_INBOX'),
        toName: 'inbox_reports_index',
        activeOn: ['inbox_reports_show'],
      },
      {
        key: 'reports_team',
        label: t('SIDEBAR.REPORTS_TEAM'),
        toName: 'team_reports_index',
        activeOn: ['team_reports_show'],
      },
      {
        key: 'reports_csat',
        label: t('SIDEBAR.CSAT'),
        toName: 'csat_reports',
      },
      {
        key: 'reports_sla',
        label: t('SIDEBAR.REPORTS_SLA'),
        toName: 'sla_reports',
      },
      {
        key: 'reports_bot',
        label: t('SIDEBAR.REPORTS_BOT'),
        toName: 'bot_reports',
      },
    ],
  },
  {
    key: 'captain',
    label: t('SIDEBAR.CAPTAIN'),
    activeOn: ['captain_assistants_create_index'],
    children: [
      {
        key: 'captain_faqs',
        label: t('SIDEBAR.CAPTAIN_RESPONSES'),
        toName: 'captain_assistants_index',
        activeOn: [
          'captain_assistants_responses_index',
          'captain_assistants_responses_pending',
        ],
      },
      {
        key: 'captain_documents',
        label: t('SIDEBAR.CAPTAIN_DOCUMENTS'),
        toName: 'captain_assistants_index',
        activeOn: ['captain_assistants_documents_index'],
      },
      {
        key: 'captain_scenarios',
        label: t('SIDEBAR.CAPTAIN_SCENARIOS'),
        toName: 'captain_assistants_index',
        activeOn: ['captain_assistants_scenarios_index'],
      },
      {
        key: 'captain_playground',
        label: t('SIDEBAR.CAPTAIN_PLAYGROUND'),
        toName: 'captain_assistants_index',
        activeOn: ['captain_assistants_playground_index'],
      },
      {
        key: 'captain_inboxes',
        label: t('SIDEBAR.CAPTAIN_INBOXES'),
        toName: 'captain_assistants_index',
        activeOn: ['captain_assistants_inboxes_index'],
      },
      {
        key: 'captain_tools',
        label: t('SIDEBAR.CAPTAIN_TOOLS'),
        toName: 'captain_assistants_index',
        activeOn: ['captain_tools_index'],
      },
      {
        key: 'captain_settings',
        label: t('SIDEBAR.CAPTAIN_SETTINGS'),
        toName: 'captain_assistants_index',
        activeOn: [
          'captain_assistants_settings_index',
          'captain_assistants_guidelines_index',
          'captain_assistants_guardrails_index',
        ],
      },
    ],
  },
  {
    key: 'campaigns',
    label: t('SIDEBAR.CAMPAIGNS'),
    children: [
      {
        key: 'campaigns_live_chat',
        label: t('SIDEBAR.LIVE_CHAT'),
        toName: 'campaigns_livechat_index',
      },
      {
        key: 'campaigns_sms',
        label: t('SIDEBAR.SMS'),
        toName: 'campaigns_sms_index',
      },
      {
        key: 'campaigns_whatsapp',
        label: t('SIDEBAR.WHATSAPP'),
        toName: 'campaigns_whatsapp_index',
      },
    ],
  },
  {
    key: 'sales_assistant',
    label: t('SIDEBAR.SALES_ASSIST'),
    toName: 'sales_assist_index',
    activeOn: ['sales_assist_conversation'],
  },
  {
    key: 'portals',
    label: t('SIDEBAR.HELP_CENTER.TITLE'),
    children: [
      {
        key: 'portal_articles',
        label: t('SIDEBAR.HELP_CENTER.ARTICLES'),
        toName: 'portals_index',
        activeOn: [
          'portals_articles_index',
          'portals_articles_new',
          'portals_articles_edit',
        ],
      },
      {
        key: 'portal_categories',
        label: t('SIDEBAR.HELP_CENTER.CATEGORIES'),
        toName: 'portals_index',
        activeOn: [
          'portals_categories_index',
          'portals_categories_articles_index',
          'portals_categories_articles_edit',
        ],
      },
      {
        key: 'portal_locales',
        label: t('SIDEBAR.HELP_CENTER.LOCALES'),
        toName: 'portals_index',
        activeOn: ['portals_locales_index'],
      },
      {
        key: 'portal_settings',
        label: t('SIDEBAR.HELP_CENTER.SETTINGS'),
        toName: 'portals_index',
        activeOn: ['portals_settings_index'],
      },
    ],
  },
  {
    key: 'settings',
    label: t('SIDEBAR.SETTINGS'),
    children: [
      {
        key: 'settings_account',
        label: t('SIDEBAR.ACCOUNT_SETTINGS'),
        toName: 'general_settings_index',
      },
      {
        key: 'settings_agents',
        label: t('SIDEBAR.AGENTS'),
        toName: 'agent_list',
      },
      {
        key: 'settings_teams',
        label: t('SIDEBAR.TEAMS'),
        toName: 'settings_teams_list',
      },
      {
        key: 'settings_agent_assignment',
        label: t('SIDEBAR.AGENT_ASSIGNMENT'),
        toName: 'assignment_policy_index',
      },
      {
        key: 'settings_inboxes',
        label: t('SIDEBAR.INBOXES'),
        toName: 'settings_inbox_list',
      },
      {
        key: 'settings_labels',
        label: t('SIDEBAR.LABELS'),
        toName: 'labels_list',
      },
      {
        key: 'settings_custom_attributes',
        label: t('SIDEBAR.CUSTOM_ATTRIBUTES'),
        toName: 'attributes_list',
      },
      {
        key: 'settings_automation',
        label: t('SIDEBAR.AUTOMATION'),
        toName: 'automation_list',
      },
      {
        key: 'settings_agent_bots',
        label: t('SIDEBAR.AGENT_BOTS'),
        toName: 'agent_bots',
      },
      {
        key: 'settings_macros',
        label: t('SIDEBAR.MACROS'),
        toName: 'macros_wrapper',
      },
      {
        key: 'settings_canned_responses',
        label: t('SIDEBAR.CANNED_RESPONSES'),
        toName: 'canned_list',
      },
      {
        key: 'settings_integrations',
        label: t('SIDEBAR.INTEGRATIONS'),
        toName: 'settings_applications',
      },
      {
        key: 'settings_audit_logs',
        label: t('SIDEBAR.AUDIT_LOGS'),
        toName: 'auditlogs_list',
      },
      {
        key: 'settings_custom_roles',
        label: t('SIDEBAR.CUSTOM_ROLES'),
        toName: 'custom_roles_list',
      },
      {
        key: 'settings_sla',
        label: t('SIDEBAR.SLA'),
        toName: 'sla_list',
      },
      {
        key: 'settings_security',
        label: t('SIDEBAR.SECURITY'),
        toName: 'security_settings_index',
      },
      {
        key: 'settings_billing',
        label: t('SIDEBAR.BILLING'),
        toName: 'billing_settings_index',
      },
    ],
  },
];
